/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Visit_SiteInputs */

const en_project_visit_site = /** @type {(inputs: Project_Visit_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit website`)
};

const lv_project_visit_site = /** @type {(inputs: Project_Visit_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atvērt tīmekļvietni`)
};

/**
* | output |
* | --- |
* | "Visit website" |
*
* @param {Project_Visit_SiteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_visit_site = /** @type {((inputs?: Project_Visit_SiteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Visit_SiteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_visit_site(inputs)
	return en_project_visit_site(inputs)
});